<template>
  <a @keydown="handleTabKey">
    <slot />
  </a>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  props: {
    last: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleTabKey: function(event) {
      if (this.last && event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault()
        eventBus.$emit('select:trigger')
      }
    },
    setFocus: function() {
      this.$el.focus()
    },
  },
  mounted() {
    if (this.last === '1') {
      eventBus.$on('select:menu:last', this.setFocus)
    }
  },
}
</script>
